import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@showroomjs/bundles/routing';
import * as React from 'react';
import { styled } from '../stitches.config';
export const Breadcrumbs = React.forwardRef(function Breadcrumbs(props, forwardedRef) {
    return (_jsx(Root, { "aria-label": "Breadcrumb", ref: forwardedRef, children: _jsx(Ol, { role: "list", children: props.items.map((item, i) => (_jsxs(Item, { children: [i > 0 && (_jsx(Svg, { viewBox: "0 0 24 44", preserveAspectRatio: "none", fill: "currentColor", "aria-hidden": "true", children: _jsx("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" }) })), item.url ? (_jsx(Text, { as: Link, to: item.url, css: {
                            '&:hover': {
                                borderBottomColor: '$gray-300',
                            },
                        }, children: item.label })) : (_jsx(Text, { children: item.label }))] }, i))) }) }));
});
const Root = styled('nav', {
    background: 'White',
    display: 'flex',
    borderBottom: '1px solid $gray-200',
});
const Ol = styled('ol', {
    display: 'flex',
    gap: '4',
    width: '100%',
    listStyleType: 'none',
    margin: 0,
});
const Item = styled('li', {
    display: 'flex',
    alignItems: 'center',
});
const Svg = styled('svg', {
    width: 24,
    height: '100%',
    flexShrink: 0,
    color: '$gray-200',
});
const Text = styled('span', {
    marginLeft: '$4',
    paddingLeft: '$2',
    paddingRight: '$2',
    fontSize: '$sm',
    lineHeight: '$sm',
    color: '$gray-500',
    textDecoration: 'none',
    borderBlock: '1px solid transparent',
    '&:hover': {
        color: '$gray-700',
    },
});
//# sourceMappingURL=breadcrumbs.js.map